import { Modal } from "react-bootstrap"
import { useMutation } from "react-query"
import TemplateForm from "./TemplateForm"
import { updateTemplate } from "../../../../../../../models/settings/template-messages"
import { toast } from "react-toastify"


const EditTemplateModal = ({ queryClient, show, onHide, queryKey, template }) => {
    const { isLoading, mutate } = useMutation(data => updateTemplate(template.id, data), {
        onError: () => toast.error('Failed to update template'),
        onSuccess: () => {
            toast.success('Template updated')
            queryClient.invalidateQueries([queryKey])
            onHide()
        }
    })

    return (
        <Modal show={show} onHide={onHide} centered keyboard={false} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Edit Template Message</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TemplateForm onSubmit={values => mutate(values)} isLoading={isLoading} data={template} />
            </Modal.Body>
        </Modal>
    )
}

export default EditTemplateModal